import { render, staticRenderFns } from "./GeneralReleaseOfLiability.vue?vue&type=template&id=584c371e&scoped=true&"
import script from "./GeneralReleaseOfLiability.vue?vue&type=script&lang=js&"
export * from "./GeneralReleaseOfLiability.vue?vue&type=script&lang=js&"
import style0 from "./GeneralReleaseOfLiability.vue?vue&type=style&index=0&id=584c371e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c371e",
  null
  
)

export default component.exports